<template>
  <section class="container">

    <div class="row mt-3">
      <div class="col-12 mb-1 text-center">
        <div>
          <span class="h1 text-style">แชะ</span> <span class="sub-text-style">AND</span> <span class="h1 text-style">แชร์</span>
        </div>
        <div class="d-flex justify-content-center">
          <span class="h4 shiny-text" style="padding-top: 5px;">SHINY HOME BY BENEAT</span>
          <div @click="openInfo" class="d-flex flex-column align-content-center pl-1 btn">
            <i class="fa fa-info-circle p-0 " style="color: #616161;"></i>
            <span style="font-size: 9px; color: #616161;">รายละเอียด</span>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-3">

      <div class="col-12 col-md-6 form-group text-center example-snap">
        <div class="card">
          <div class="card-header text-center">
            <h3 style="margin: 0;">ตัวอย่าง การอัพโหลดรูป</h3>
          </div>
          <div class="card-body text-center">
            <b-img-lazy src="/static/img/snapAndShare/snap_and_share_example.jpg" class="img-fluid" alt=""></b-img-lazy>
          </div>
        </div>
      </div>

      <div class="col-12 col-md-6">
        <b-form @submit.prevent="submit" data-vv-scope="form-snapAndShare">
          <div class="row mt-3">
            <div class="col-12 col-md-12 form-group">
              <label for="tel">เบอร์โทร<span class="text-danger">*</span></label>
              <b-form-input
                class="form-control"
                id="tel"
                type="tel"
                :state="state"
                placeholder="เบอร์โทร (กรอกเฉพาะตัวเลขและพิมพ์ติดกัน)"
                v-model="formReview.tel"
                required
                aria-describedby="input-live-feedback"
              ></b-form-input>
              <b-form-invalid-feedback id="input-live-feedback">
                กรุณากรอกเบอร์โทรศัพท์
              </b-form-invalid-feedback>
            </div>
            <div class="col-12 col-md-12 form-group">
              <label for="link-review">Link Post คุณลูกค้า<span class="text-danger">*</span></label>
              <b-form-input id="link-review" type="text" class="form-control" v-model="formReview.url_review" placeholder="" :state="stateUrl" required aria-describedby="input-live-feedback-url-review"></b-form-input>
              <b-form-invalid-feedback id="input-live-feedback-url-review">
                กรุณากรอก Link Post
              </b-form-invalid-feedback>
            </div>
            <div class="col-12 col-md-12 form-group">
              <label for="order-code">รหัสการจอง (optional)</label>
              <b-form-input id="order-code" type="text" class="form-control" v-model="formReview.order_code"></b-form-input>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <picture-input
                ref="pictureInput"
                width="300"
                height="200"
                accept="image/jpeg,image/png,image/gif,image/svg,image/webp"
                size="5"
                :removable="true"
                :customStrings="{
                        upload: '<p>อัพโหลดเรียบร้อย</p>',
                        drag: 'อัพโหลดรูป',
                        tap: 'อัพโหลดรูป',
                        change: 'เปลี่ยนรูป',
                        remove: 'ลบรูป',
                    }"
                :zIndex="1000"
                @change="onChange"
                @remove="onRemove"
              ></picture-input>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <div class="mb-3 mt-5">
                <div class="form-group">
                  <button type="submit" class="btn btn-block btn-info" :disabled="isSubmitting">
                    {{ isSubmitting ? 'กำลังส่งรีวิว...' : 'ส่งรีวิว' }}
                  </button>
                </div>
              </div>
            </div>
          </div>

        </b-form>
      </div>

    </div>

  </section>
</template>
<script>
import axios from 'axios'
import PictureInput from 'vue-picture-input'

export default {
  components: {
    PictureInput
  },
  data: () => ({
    isSubmitting: false,
    formReview: {
      img_review: null,
      tel: null,
      order_code: null,
      url_review: null
    },
    state: null,
    stateUrl: null
  }),
  watch: {
    'formReview.tel': function (n, o) {
      if (n) {
        this.state = null
      }
    }
  },
  methods: {
    onChange (image) {
      if (image) {
        this.formReview.img_review = image
      } else {
        this.onRemove()
      }
    },
    onRemove () {
      this.formReview.img_review = null
    },
    submit () {
      this.$validator.validateAll('form-snapAndShare').then(async (valid) => {
        if (valid) {
          /* check upload img review */
          if (!this.formReview.img_review) {
            this.$swal('ข้อมูลไม่ครบถ้วน', 'กรุณาอัปโหลดรูปภาพ', 'error')
            return
          }
          /* checko tel number */
          const rex = /^\+?[0-9-]+$/
          let phone = this.formReview.tel
          if (phone) {
            let valid = phone.match(rex)
            if (!valid) {
              this.state = false
            } else {
              this.state = false
              if (phone.length >= 10 && phone.length <= 15) {
                let phoneValid = phone.match(rex)
                if (phoneValid) {
                  this.state = true
                }
              }
            }
          } else {
            this.state = false
          }
          if (this.formReview.url_review) {
            const rex = /.*\/(.*)\/(.*)$/
            let url = this.formReview.url_review
            if (url.match(rex)) {
              this.stateUrl = true
            } else {
              this.stateUrl = false
            }
          } else {
            this.stateUrl = false
          }
          /* breck event if tel number state false */
          if (!this.state || !this.stateUrl) return
          /* api input */
          let formData = new FormData()
          formData.append('img_review', this.formReview.img_review)
          formData.append('tel', this.formReview.tel)
          if (this.formReview.order_code) {
            formData.append('order_code', this.formReview.order_code)
          }
          if (this.formReview.url_review) {
            formData.append('url_review', this.formReview.url_review)
          }
          const url = '/marketing-campaign'
          try {
            this.isSubmitting = true // loading active
            const { data } = await axios.post(url, formData)
            if (!data.error) {
              this.initForm()
              this.$swal('ส่งรีวิวสำเร็จ', '', 'success')
            } else {
              this.isSubmitting = false
            }
          } catch (error) {
            this.isSubmitting = false
          }
        }
      })
    },
    async initForm () {
      this.isSubmitting = false
      this.state = null
      this.formReview.img_review = null
      this.formReview.tel = null
      this.formReview.order_code = null
      this.formReview.url_review = null
      if (this.$refs.pictureInput) {
        this.$refs.pictureInput.removeImage()
      }
    },
    openInfo () {
      this.$swal({
        showConfirmButton: false,
        showCloseButton: true,
        backdrop: false,
        imageUrl: '/static/img/snapAndShare/snap-and-share.png'
      })
    }
  },
  created () {
    this.initForm()
  }
}
</script>
<style lang="scss" scoped>
@import "~bootstrap/scss/_functions.scss";
@import "~bootstrap/scss/_variables.scss";
@import "~bootstrap/scss/mixins/breakpoints";

.text-style {
  color: #3bbcd4;
}

.sub-text-style {
  text-shadow: -2px 2px 1px #ebebeb;
  color: #00bcd4;
  font-weight: 500;
}

.shiny-text {
  text-shadow: -2px 2px 1px #3bbcd4;
  color: #fff;
  font-weight: 500;
}

div.example-snap {
  padding: 15px;
}


@include media-breakpoint-down(md) {
  span.sub-text-style {
    font-size: 1.5rem;
  }
}

@include media-breakpoint-up(lg) {
  div.example-snap {
    padding: 0 100px 100px 100px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/campaign/snapAndShare/index.vue